import { useEstadoConexion } from '@/hooks/useEstadoConexion';
import { useMutacionesPendientes } from '@/hooks/useMutacionesPendientes';
import { CloudSlash, WifiHigh } from '@phosphor-icons/react';

/**
 * Badge en el header que indica el estado de conexión.
 *
 *   Online + 0 pendientes → verde 'En línea'
 *   Online + N pendientes → amber 'Sincronizando N'
 *   Offline               → rojo 'Sin conexión' (+ N pendientes si los hay)
 */
export function IndicadorConexion() {
  const online = useEstadoConexion();
  const pendientes = useMutacionesPendientes();

  if (!online) {
    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full bg-red-500/15 px-2.5 py-1 text-xs font-medium text-red-300"
        title="Sin conexión a Internet — los cambios se guardarán y sincronizarán al reconectar"
      >
        <CloudSlash className="h-3.5 w-3.5" weight="bold" aria-hidden="true" />
        Sin conexión
        {pendientes > 0 && (
          <span className="ml-1 rounded-full bg-red-500/30 px-1.5 py-0.5 text-[10px]">
            {pendientes}
          </span>
        )}
      </span>
    );
  }

  if (pendientes > 0) {
    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full bg-amber-500/15 px-2.5 py-1 text-xs font-medium text-amber-300"
        title={`${pendientes} cambios esperando sincronizar al backend`}
      >
        <WifiHigh className="h-3.5 w-3.5 animate-pulse" weight="bold" aria-hidden="true" />
        Sincronizando {pendientes}
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full bg-adelante-primary/20 px-2.5 py-1 text-xs font-medium text-adelante-primary"
      title="En línea — los cambios se guardan inmediatamente en AdelanteDB"
    >
      <WifiHigh className="h-3.5 w-3.5" weight="bold" aria-hidden="true" />
      En línea
    </span>
  );
}
